import { useMessageRoutes } from "./routes";
import { DateTimeViewer, GetDefaultIndex } from "../../components";
import { Descriptions } from "antd";
import { useGetMessageCommonInfoQuery } from "../../features/identity/messagesApi";
import { MessageInfoModel } from "../../entities/message";

export { useMessageRoutes };

export default GetDefaultIndex({
  title: "پیام‌ها",
  query: useGetMessageCommonInfoQuery,
  generalInfoPresentor: (info: MessageInfoModel) =>
    info ? (
      <Descriptions size="small" column={{ xxl: 4, xl: 3, lg: 2, md: 2, sm: 1, xs: 1 }}>
        <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
          {info.totalRecords}
        </Descriptions.Item>
        <Descriptions.Item label="خوانده نشده" labelStyle={{ color: "gray" }}>
          {info.unreadRecords}
        </Descriptions.Item>
        <Descriptions.Item label="آخرین اضافه" labelStyle={{ color: "gray" }}>
          <DateTimeViewer value={info.lastCreateAt} mode="distance" />
        </Descriptions.Item>
      </Descriptions>
    ) : null,
});
